module.exports = __webpack_public_path__ + "static/media/remove_icon.208ff39f.png";